import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES } from "../../assets/asset";

const CreateAccount = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupWithEmail = () => {
    navigate("/createaccountform");
  };

  const buttonClass =
    "flex items-center justify-center rounded-lg py-2 transition duration-300";

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-blue-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      role="main"
      aria-labelledby="create-account-title"
    >
      <div
        className="absolute top-5 left-5 cursor-pointer"
        onClick={() => navigate(-1)}
        role="button"
        aria-label="Go back to the previous page"
      >
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          alt="Back"
          className="w-10 h-10"
        />
      </div>
      <div
        className="bg-white bg-opacity-60 p-12 rounded-lg shadow-lg max-w-lg w-full"
        role="region"
        aria-labelledby="create-account-title"
        aria-describedby="create-account-description"
      >
        <h2
          id="create-account-title"
          className="text-3xl font-bold text-center text-gray-800 mb-6"
        >
          Create account
        </h2>
        <p
          id="create-account-description"
          className="text-center text-gray-600 mb-8"
        >
          Login or sign up to save your kids' progress as they work through
          courses on the
          <span className="font-bold text-indigo-600"> MATHDINGO</span>{" "}
          application
        </p>

        <div className="flex flex-col space-y-4">
          {/* <button
            className={`${buttonClass} bg-white text-gray-700 border border-gray-300 hover:bg-gray-100`}
            aria-label="Sign up with Google"
          >
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt="Google"
              className="w-6 h-6 mr-2"
            />
            Signup with Google
          </button> */}
          <button
            className={`${buttonClass} bg-blue-800 text-white hover:bg-blue-900`}
            onClick={handleSignupWithEmail}
            aria-label="Sign up with Email"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Mail_%28iOS%29.svg"
              alt="Mail"
              className="w-6 h-6 mr-2"
            />
            Signup with Email
          </button>
        </div>

        <div className="text-center text-black mt-6">
          <div className="border-t border-black my-4"></div>
          <p className="text-black-600 md:font-bold">Already registered?</p>
          <button
            className={`${buttonClass} bg-white text-gray-700 border border-gray-300 hover:bg-gray-100`}
            style={{ width: "100%" }}
            onClick={handleLoginClick}
            aria-label="Login to your account"
          >
            Login
          </button>

          <div className="flex justify-between mt-4">
            <a
              href="https://mathdingo.com/terms_of_use.html"
              target="_blank"
              className="text-black font-bold text-sm underline"
              style={{ flex: 1, textAlign: "center" }}
              aria-label="Read subscription use"
            >
              Read Subscription Use
            </a>
            <Link to={`/contact`}>
              <div
                className="text-black font-bold text-sm underline"
                style={{ flex: 1, textAlign: "center" }}
                aria-label="Contact us for support"
              >
                Contact Us
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
